import HttpException from 'exceptions/HttpException'

export default class HttpInternalServerException extends HttpException {
  constructor(message, ...args) {
    super('Internal Server Error', message, ...args)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HttpInternalServerException)
    }

    this.code = 500
  }
}
